export default "__VITE_ASSET__BCADqJPC__"